import React, { useState } from 'react';

const ChatInput = ({ inputMessage, setInputMessage, handleSendMessage, isLoading }) => {
  const [showEmojiPicker, setShowEmojiPicker] = useState(false);

  // Danh sách emoji (có thể mở rộng)
  const emojis = [
    { src: 'assets/img/icons/emonji-02.svg', alt: 'Emoji 1', value: '😊' },
    { src: 'assets/img/icons/emonji-05.svg', alt: 'Emoji 2', value: '🌟' },
    { src: 'assets/img/icons/emonji-06.svg', alt: 'Emoji 3', value: '🌈' },
    { src: 'assets/img/icons/emonji-07.svg', alt: 'Emoji 4', value: '📸' },
    { src: 'assets/img/icons/emonji-08.svg', alt: 'Emoji 5', value: '🌳' },
  ];

  // Xử lý chọn emoji
  const handleEmojiClick = (emojiValue) => {
    setInputMessage((prev) => prev + emojiValue);
    setShowEmojiPicker(false);
  };

  // Xử lý toggle danh sách emoji
  const toggleEmojiPicker = () => {
    setShowEmojiPicker((prev) => !prev);
  };

  return (
    <div className="card-footer border-0">
      <div className="d-flex align-items-center">
        <div className="d-flex align-items-center chat-input-icons">
          <a className="btn no-bg" data-bs-toggle="dropdown" aria-expanded="false">
            <i className="ti ti-dots-vertical"></i>
          </a>
          <div className="dropdown-menu dropdown-menu-end p-3">
            <a className="dropdown-item">
              <i className="isax isax-camera me-2"></i>Camera
            </a>
            <a className="dropdown-item">
              <i className="isax isax-gallery me-2"></i>Thư viện
            </a>
            <a className="dropdown-item">
              <i className="isax isax-audio-square me-2"></i>Âm thanh
            </a>
            <a className="dropdown-item">
              <i className="isax isax-location me-2"></i>Vị trí
            </a>
            <a className="dropdown-item">
              <i className="isax isax-user-cirlce-add me-2"></i>Liên hệ
            </a>
          </div>
          <div className="form-item emoj-action-foot">
            <a href="javascript:void(0);" className="action-circle" onClick={toggleEmojiPicker}>
              <i className="fa-regular fa-face-smile"></i>
            </a>
            {showEmojiPicker && (
              <div className="emoj-group-list-foot down-emoji-circle">
                <ul>
                  {emojis.map((emoji, index) => (
                    <li key={index}>
                      <a onClick={() => handleEmojiClick(emoji.value)}>
                        <img src={emoji.src} alt={emoji.alt} />
                      </a>
                    </li>
                  ))}
                  <li className="add-emoj">
                    <a>
                      <i className="isax isax-add"></i>
                    </a>
                  </li>
                </ul>
              </div>
            )}
            <a>
              <i className="isax isax-microphone-2"></i>
            </a>
          </div>
        </div>
        <div className="chat-input me-2">
          <input
            className="form-control"
            placeholder="Nhập câu hỏi của bạn..."
            value={inputMessage}
            onChange={(e) => setInputMessage(e.target.value)}
            onKeyPress={(e) => e.key === 'Enter' && handleSendMessage()}
            disabled={isLoading}
          />
        </div>
        <div>
          <button
            className="btn btn-primary btn_send"
            onClick={handleSendMessage}
            disabled={isLoading}
          >
            <i className="isax isax-send-25 text-white" aria-hidden="true"></i>
          </button>
        </div>
      </div>
    </div>
  );
};

export default ChatInput;